import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    shipTos: [],
    applications: [],
    navigation: [],
    revalidationStatus: ''
  },
  mutations: {
    setUser(state, value) {
      state.user = value
    },
    setShipTos(state, value) {
      if (value.length === 0) {
        Vue.$axios.get('/api/v1/user/prospect').then(success => {
          //go to order app if user does not have shipto and the user is prospect user
          if (success.data != null && success.data !== '') {
            window.location.href = window.__env.orderUrl
          }
        })
      } else {
        state.shipTos = value
      }
    },
    setApplications(state, value) {
      state.applications = value
    },
    setNavigation(state, value) {
      state.navigation = value
    },
    setRevalidationStatus(state, value) {
      if (value !== null && value !== '' && value.length > 0) {
        state.revalidationStatus = 'RequiresRevalidation'
      }
    }
  },
  actions: {
    getUser({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.$axios.get('/api/v1/user/info').then(
          success => {
            commit('setUser', success.data)
            resolve()
          },
          error => {
            reject(error)
          }
        )
      })
    },
    getShipTos({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.$axios.get('/api/v1/user/shiptos').then(
          success => {
            commit('setShipTos', success.data)
            resolve()
          },
          error => {
            reject(error)
          }
        )
      })
    },
    getApplications({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.$axios.get('/api/v1/user/applications').then(
          success => {
            commit('setApplications', success.data)
            resolve()
          },
          error => {
            reject(error)
          }
        )
      })
    },
    getRevalidationStatus({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.$axios.get('/api/v1/user/revalidationStatus').then(
          success => {
            commit('setRevalidationStatus', success.data)
            resolve()
          },
          error => {
            reject(error)
          }
        )
      })
    }
  }
})
